module.exports = __webpack_public_path__ + "static/media/share-ic.5d3e6a19.svg";